import { IDashboardWidget } from './dashboard-widget.interface';
import * as DashboardAction from './dashboard.action';
import { Action, createReducer, on } from '@ngrx/store';

export interface IDashboardState {
  widgets: IDashboardWidget[];
  pending: boolean;
  initiated: boolean;
}

export const dashboardInitialState: IDashboardState = {
  widgets: [],
  pending: false,
  initiated: false,
};

const reducer = createReducer(
  dashboardInitialState,

  on(DashboardAction.DashboardInit, (state) => ({
    ...state,
    pending: true,
    initiated: false,
  })),

  on(DashboardAction.DashboardInitSuccess, (state, action) => ({
    ...state,
    pending: false,
    initiated: true,
    widgets: action.widgetsSettings,
  })),

  on(DashboardAction.DashboardInitFail, (state) => ({
    ...state,
    pending: false,
    initiated: false,
  })),

  on(DashboardAction.DashboardWidgetSettingsUpdate, (state, _) => ({
    ...state,
    pending: true,
  })),

  on(DashboardAction.DashboardWidgetSettingsUpdateSuccess, (state, action) => ({
    ...state,
    pending: false,
    widgets: action.widgetsSettings,
  })),

  on(DashboardAction.DashboardWidgetSettingsUpdateFail, (state, _) => ({
    ...state,
    pending: false,
  })),

  on(DashboardAction.DashboardWidgetSettingsListUpdate, (state, _) => ({
    ...state,
    pending: true,
  })),

  on(DashboardAction.DashboardWidgetSettingsListUpdateSuccess, (state, action) => ({
    ...state,
    pending: false,
    widgets: action.widgetsSettings,
  })),

  on(DashboardAction.DashboardWidgetSettingsListUpdateFail, (state, _) => ({
    ...state,
    pending: false,
  }))
);

export const dashboardReducer = (state: IDashboardState | undefined, action: Action): IDashboardState => reducer(state, action);
